import SchoolInformation from './SchoolInformation.page';

export default SchoolInformation;
